
import {createSlice} from "@reduxjs/toolkit";

export const contractDataPointValueFilterSlice = createSlice({
    name: 'contractDataPointValueFilterSlc',
    initialState: {value: {
        id: null,
            contractDataPointId: null,
            contractDataPointValueId: 11,
            parentFilterId: null,
            previousFilterId: null,
            ordinalNumber: null,
            recordLevel: null,
            dataPointId: null,
            singleValue: null,
            singleValueNumber: null,
            fromValue: null,
            toValue: null,
             status: null,
            hierarchy: null,
            cdpvMockValue: null,
            expressionIndicator: null,
            mockExpression: null,
            mockExpressionTranslation: null,
            createdOn: null,
            createdBy: null,
            lastModifiedOn: null,
            lastModifiedBy: null,
            expressionIndicatorOld: null,
            mockExpressionOld: null,
            mockExpressionTranslationOld: null,
            cdpvCount: null,
            dataPointName: null,
            dataType: null,
            displaySingleValue: null,
            displayFromValue: null,
            displayToValue: null,
            cdpDataPointId: null,
            cdpDataPointName: null,
            cdpDataType: null,
            mockOrigin: null,
            cdpvValue: null,
            expression: null,
            expressionTranslation: null,
            expressionDescription: null,
            mockValue: null,
            parentDataPointId: null,
            parentDataPointName: null,
            parentDataType: null,
            parentDisplaySingleValue: null,
            parentDisplayFromValue: null,
            parentDisplayToValue: null,
            // cdpvfDrawerState: false, cdpvfDrawerMode: null, cdpvfGridState: false, cdpvfGridRefresh: false, cdpvfCount: 0,
            // cdpvfDrawerContext: "none", cdpvGridState: false, cdpvfRebuildHierarchy: false
        }},
    reducers:

{
    changeContractDataPointValueFilter: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContractDataPointValueFilter } = contractDataPointValueFilterSlice.actions;

export default  contractDataPointValueFilterSlice.reducer ;
